import React from 'react'
import './TitleLine.sass'

export default function TitleLine() {
    return (
        <span className='TitleLine' />
    )
}
